import { IStyle } from '@fluentui/react';
import { FontSizes, FontWeights, IH2OTheme } from '@h2oai/ui-kit';

export interface IIngestHistoryListStyles {
  root?: IStyle;
  cardView?: IStyle;
  scopeContainer?: IStyle;
  scope?: IStyle;
  scopeTitle?: IStyle;
  scopeValue?: IStyle;
}

export interface IIngestHistoryListClassNames {
  root: string;
  cardView: string;
  scopeContainer: string;
  scope: string;
  scopeTitle: string;
  scopeValue: string;
}

export const IngestHistoryListStylesDefault = (theme: IH2OTheme): Partial<IIngestHistoryListStyles> => ({
  root: {
    display: 'flex',
    flex: 1,
    minHeight: 0,
    marginTop: '16px',
  },
  cardView: {
    flex: 1,
    overflow: 'auto',
  },
  scopeContainer: {
    display: 'flex',
    paddingLeft: '16px',
    paddingRight: '16px',
    gap: '8px',
    borderLeft: `1px solid ${theme.semanticColors?.inputBorder}`,
    borderRight: `1px solid ${theme.semanticColors?.inputBorder}`,
  },
  scope: {
    fontWeight: FontWeights.semiBold,
    lineHeight: '72px',
  },
  scopeTitle: { fontWeight: FontWeights.semiBold, fontSize: FontSizes.xxsmall },
  scopeValue: {
    color: theme.semanticColors?.textSecondary,
  },
});
